let loading = null;

export const loadFbSdk = ({ app_id, version }) => {
  if (window.FB) return Promise.resolve(window.FB);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    window.fbAsyncInit = () => {
      window.FB.init({ appId: app_id, autoLogAppEvents: true, xfbml: false, version });
      resolve(window.FB);
    };
    const s = document.createElement("script");
    s.src = "https://connect.facebook.net/en_US/sdk.js";
    s.async = true;
    s.defer = true;
    s.crossOrigin = "anonymous";
    s.onerror = () => { loading = null; reject(new Error("Could not load the Facebook SDK")); };
    document.body.appendChild(s);
  });
  return loading;
};

export const parseSignupMessage = (event) => {
  if (!String(event.origin).endsWith("facebook.com")) return null;
  try {
    const d = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    return d?.type === "WA_EMBEDDED_SIGNUP" ? d : null;
  } catch {
    return null;
  }
};
